import { piloteerApi, useGetUserQuery } from '@/api/piloteer';
import { authService } from '@/services/auth';
import {
  setSession,
  setError as setSessionError,
  setLoading as setSessionLoading,
} from '@/store/auth/slice';
import { useAppDispatch } from '@/store/hooks';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/ui/@components/primitives/avatar';
import { Button } from '@/ui/@components/primitives/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/ui/@components/primitives/dropdown-menu';
import { APP_ROUTES } from '@/ui/application-routes';
import { getUserInitials } from '@/utils/user';
import { ChevronDownIcon } from 'lucide-react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

export const AvatarDropdown: FunctionComponent = () => {
  const { data: user } = useGetUserQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSignOut = async () => {
    dispatch(setSessionLoading(true));
    dispatch(setSessionError(null));
    const { error } = await authService.signOut({ scope: 'local' });
    if (error) {
      const { data } = await authService.getSession();
      dispatch(setSession(data.session));
      dispatch(setSessionError(error));
      dispatch(setSessionLoading(false));
      return;
    }
    dispatch(setSession(null));
    dispatch(piloteerApi.util.resetApiState());
    navigate(APP_ROUTES.ROOT);
  };

  const userInitials = getUserInitials(user?.name);

  return (
    <div className='flex-initial'>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            asChild
            className='pl-0 pr-1 py-0 rounded-full h-8'
            variant='ghost'
          >
            <div className='flex items-center space-x-1'>
              <Avatar className='rounded-full h-8 w-8'>
                <AvatarImage
                  src={user?.profilePicture}
                  className='object-cover rounded-full h-8 w-8'
                />
                <AvatarFallback>{userInitials ?? '?'}</AvatarFallback>
              </Avatar>

              <span className='sr-only'>Toggle user menu</span>
              <ChevronDownIcon className='w-4 h-4' />
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='end' className='rounded-lg'>
          <DropdownMenuLabel>
            {user?.name || user?.email?.split('@')[0] || 'Account'}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          {/* <DropdownMenuItem asChild>
            <Link to={APP_ROUTES.SETTINGS.BILLING}>Billing</Link>
          </DropdownMenuItem> */}
          <DropdownMenuItem asChild>
            <Link to={APP_ROUTES.SETTINGS.MAIN}>{t('user.settings')}</Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleSignOut}>
            {t('user.logout')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
